import {
  EnvironmentProviders,
  makeEnvironmentProviders,
  provideAppInitializer,
} from '@angular/core';
import { IContext } from 'unleash-proxy-client';
import { UnleashService } from './unleash.service';

export const provideUnleash = (config: {
  instance: string;
  clientKey: string;
  environment: string;
  metricsInterval?: number;
  refreshInterval?: number;
  releaseEnvironment?: 'dev' | 'test' | 'acc' | 'stag' | 'prod';
}): EnvironmentProviders => {
  return makeEnvironmentProviders([
    provideAppInitializer(() => {
      UnleashService.init(
        config.instance,
        config.clientKey,
        config.environment,
        config.refreshInterval || 30,
        config.metricsInterval || 30,
        config.releaseEnvironment || '',
      );
    }),
  ]);
};

export interface UnleashEvent {
  context: IContext;
  enabled: boolean;
  eventId: string;
  eventType: string;
  featureName: string;
  variant?: string;
  payload?: Record<string, unknown>;
}

export type UnleashEventType =
  'impression' | 'ready' | 'init' | 'error' | 'update';
